module.exports = __webpack_public_path__ + "images/FUSA_icons/058-chat.ab51c11be93e65a4fb75f1d80cd70198.svg";